import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'fe-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnChanges {
    private static instanceCounter = 0;

    @Input() isSidebarVisible = false;
    @Input() international = false;
    @Output() toggleSidebar = new EventEmitter<void>();
    @Output() sortChange = new EventEmitter<string>();

    readonly uid = `filters-${FiltersComponent.instanceCounter++}`;
    selectedRadio = 'featured';

    isMobile = false;

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.isMobile = window.innerWidth <= 540;
    }

    ngOnInit() {
        this.isMobile = window.innerWidth <= 540;
        this.syncSortWithOrigin(false);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['international'];
        if (change && !change.firstChange) {
            this.syncSortWithOrigin(true);
        }
    }

    private syncSortWithOrigin(emit: boolean): void {
        if (!this.international || this.selectedRadio !== 'featured') {
            return;
        }
        this.selectedRadio = 'lowerPrice';
        if (emit) {
            this.sortChange.emit(this.selectedRadio);
        }
    }

    closeSidebar() {
        this.toggleSidebar.emit();
    }

    selectRadio(id: string) {
        this.selectedRadio = id;
        this.sortChange.emit(id);
    }
}
